const [{
	"First & Last Name": fullName,
	"Registrant ID": userId,
	"Email Address": emailL,
	"email": emailJ,
	"Event Name": event,
	"Event ID": eventIdSw,
	"last_name": lastName,
	"first_name": firstName,
	"firstName": firstNameP,
	"lastName": lastNameP,
	"event_name": eventNameJwt,
	"Headshot": headshotJ,
	"Company": companyF,
	"Please make it more personal by uploading a head and shoulders photo:": avatarF,
    "Please upload a headshot:": headshotB,
	platformEventId,
	"company": companyJ,
	eventId,
	id,
	c_1038492
}] = window.dataLayer

export const userName = fullName || [firstName || firstNameP, lastName || lastNameP].join(" ")
export const userID = userId || id
export const eventName = event || eventNameJwt
export const eventID = eventIdSw || platformEventId
export const stapID = eventId
export const headshot = headshotJ || c_1038492 || headshotB
export const company = companyF || companyJ
export const avatar = avatarF || headshot
export const email = emailL || emailJ